<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400px" persistent>
      <v-card>
        <v-card-title style="word-break: normal !important; justify-content: center">{{ title }}</v-card-title>
        <v-card-text>
          <slot />
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn color="primary" tile width="50%" :disabled="confirmDisabled" @click="confirm()">
            {{ $t('subOrder.confirm') }}
          </v-btn>
          <v-btn color="secondary" class="ml-0" width="50%" tile @click="close()">
            {{ $t('subOrder.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'SelectionDialog',
    props: {
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      confirmDisabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      confirm() {
        this.$emit('confirm')
        this.show = false
      },
      close() {
        this.$emit('close')
        this.show = false
      },
    },
  }
</script>
